// @ts-ignore
import { PROBLEM_INNER_TYPES, PROBLEM_STATUSES } from '@yandex-int/k-common/constants';

import { CriteriaStats } from 'common.components/results/typings';

export enum PROBLEM_DISPLAY_STATUS {
    PROBLEM_NOT_VIEWED = 'notViewed',
    PROBLEM_VIEWED = 'viewed',
    PROBLEM_NOT_COMPLETED = 'notCompleted',
    PROBLEM_COMPLETED = 'completed',
    PROBLEM_CORRECT = 'correct',
    PROBLEM_INCORRECT = 'incorrect',
    PROBLEM_PARTIAL = 'partial',
}

export interface ProblemDisplayStatusData {
    type: number | null;
    time: string | number;
    answered: boolean;
    attemptNumber: number | null;
    maxAttempts: number;
    problemStatus: PROBLEM_STATUSES;
    criteriaStats?: CriteriaStats;
}

// eslint-disable-next-line complexity
export const getDisplayStatus = (problemResult: ProblemDisplayStatusData): PROBLEM_DISPLAY_STATUS => {
    const { type, time = 0, answered, attemptNumber, maxAttempts, problemStatus, criteriaStats } = problemResult;
    const hasAttempts = attemptNumber && attemptNumber < maxAttempts;

    if (criteriaStats) {
        if (criteriaStats.correct === criteriaStats.max) {
            return PROBLEM_DISPLAY_STATUS.PROBLEM_CORRECT;
        }
        if (criteriaStats.incorrect === criteriaStats.max) {
            return PROBLEM_DISPLAY_STATUS.PROBLEM_INCORRECT;
        }
        if (criteriaStats.correct > 0 || criteriaStats.incorrect > 0) {
            return PROBLEM_DISPLAY_STATUS.PROBLEM_PARTIAL;
        }
    }

    if ([PROBLEM_INNER_TYPES.THEORY, PROBLEM_INNER_TYPES.EDITABLE].includes(type)) {
        if (!time) {
            return PROBLEM_DISPLAY_STATUS.PROBLEM_NOT_VIEWED;
        }

        if (type === PROBLEM_INNER_TYPES.EDITABLE && answered) {
            return PROBLEM_DISPLAY_STATUS.PROBLEM_COMPLETED;
        }

        return PROBLEM_DISPLAY_STATUS.PROBLEM_VIEWED;
    }

    // eslint-disable-next-line default-case
    switch (problemStatus) {
        case PROBLEM_STATUSES.CORRECT:
            return PROBLEM_DISPLAY_STATUS.PROBLEM_CORRECT;
        case PROBLEM_STATUSES.INCORRECT:
            return PROBLEM_DISPLAY_STATUS.PROBLEM_INCORRECT;
    }

    if (answered && !hasAttempts) {
        return PROBLEM_DISPLAY_STATUS.PROBLEM_COMPLETED;
    }

    return PROBLEM_DISPLAY_STATUS.PROBLEM_NOT_COMPLETED;
};

export const toKebabCase = (name: string): string => {
    return name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
};
